import { useEffect, useState } from "react";

type TimedNoResultsOptions = {
  query: string;
  enabled: boolean;
  loading: boolean;
  ready: boolean;
  hasResults: boolean;
  delayMs?: number;
};

export function useTimedNoResults({
  query,
  enabled,
  loading,
  ready,
  hasResults,
  delayMs = 3_000
}: TimedNoResultsOptions) {
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    setDismissed(false);
  }, [query]);

  useEffect(() => {
    if (!enabled || loading || !ready || hasResults) return;
    const timer = window.setTimeout(() => setDismissed(true), delayMs);
    return () => window.clearTimeout(timer);
  }, [delayMs, enabled, hasResults, loading, ready]);

  return dismissed;
}
